<template>
  <Dialog
    :visible.sync="dialogVisible"
    :style="{ width: $isMobile() ? '100vw' : '30vw' }"
    :modal="true"
    header="Alterar Estado dos PATs"
  >
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-mt-2">
        <label>PATs selecionados</label>
        <InputText :value="patIdsList" disabled />
      </div>

      <div class="p-field p-col-12 p-mt-2">
        <label>Estado atual</label>
        <InputText :value="currentStatus" disabled />
      </div>

      <div class="p-field p-col-12 p-mt-2">
        <label for="newStatus">Novo estado</label>
        <Dropdown
          id="newStatus"
          :options="availableStatuses"
          v-model="newStatus"
          optionLabel="field"
          optionValue="field"
          placeholder="Selecionar novo estado"
          filter
          appendTo="body"
        />
      </div>

      <div class="p-grid p-jc-center p-col-12 p-mt-3">
        <div class="p-col-12 p-md-6 p-mt-2">
          <Button
            icon="pi pi-check"
            label="Alterar"
            class="p-button-success"
            :disabled="!newStatus || isLoading"
            @click="submit"
          />
        </div>
        <div class="p-col-12 p-md-6 p-mt-2">
          <Button
            icon="pi pi-times"
            label="Cancelar"
            :disabled="isLoading"
            @click="cancel"
          />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import PatService from "@/services/pat.service";

export default {
  name: "ChangeStatusDialog",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    selectedPats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allStatuses: [],
      newStatus: null,
      isLoading: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    currentStatus() {
      if (!this.selectedPats || this.selectedPats.length === 0) return "";
      return this.selectedPats[0].status || "";
    },
    patIdsList() {
      if (!this.selectedPats || this.selectedPats.length === 0) return "";
      return this.selectedPats.map((p) => p.id).join(", ");
    },
    availableStatuses() {
      return this.allStatuses.filter((s) => s.field !== this.currentStatus);
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.newStatus = null;
      }
    },
  },
  async created() {
    this.allStatuses = await PatService.getAllStatus();
  },
  methods: {
    async submit() {
      if (!this.newStatus) return;

      this.isLoading = true;
      try {
        const patIds = this.selectedPats.map((p) => p.id);
        await PatService.bulkChangeStatus(patIds, this.newStatus);

        this.$toast.add({
          severity: "success",
          summary: "Estado alterado",
          detail: `${patIds.length} PAT(s) alterado(s) para "${this.newStatus}"`,
          life: 3000,
        });

        this.dialogVisible = false;
        this.$emit("updated");
      } catch (error) {
        const detail =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Erro ao alterar o estado dos PATs";
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail,
          life: 4000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.$emit("cancel");
    },
  },
};
</script>
